function searchSorter() {
  const sorter = document.querySelector('#search-sorter');

  if (!sorter) return;

  sorter.addEventListener('change', (event) => {
    const selectedOrder = event.target.value;
    const url = new URL(window.location.href);

    url.searchParams.set('order', selectedOrder);
    url.searchParams.delete('page');

    if (
      (selectedOrder === 'price_asc' || selectedOrder === 'price_desc') &&
      !url.searchParams.has('initial_profile') &&
      event.target.dataset.profile
    ) {
      url.searchParams.set('initial_profile', event.target.dataset.profile);
    }

    window.location.assign(url.toString());
  });
}

document.addEventListener('DOMContentLoaded', searchSorter);
